const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 md:py-32">
      {/* Gradient background */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(circle at top right, var(--color-accent-3), transparent 50%)',
        }}
      />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center md:text-center text-left">
          {/* Heading */}
          <h1
            className="text-3xl md:text-4xl lg:text-6xl font-bold mb-6"
            style={{ color: 'var(--color-heading)' }}
          >
            Chess for Social Impact
          </h1>

          {/* Subheading */}
          <p
            className="text-base md:text-xl lg:text-2xl mb-8 leading-relaxed"
            style={{ color: 'var(--color-subheading)' }}
          >
            Using chess as a tool for transformation, rehabilitation, and hope across communities worldwide
          </p>

          {/* Impact Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-12">
            <div
              className="p-5 md:p-6 rounded-lg"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              <div
                className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2"
                style={{ color: 'var(--color-accent-6)' }}
              >
                2+
              </div>
              <div
                className="text-sm md:text-base lg:text-lg"
                style={{ color: 'var(--color-card-text)' }}
              >
                Countries Reached
              </div>
            </div>

            <div
              className="p-5 md:p-6 rounded-lg"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              <div
                className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2"
                style={{ color: 'var(--color-accent-6)' }}
              >
                20+
              </div>
              <div
                className="text-sm md:text-base lg:text-lg"
                style={{ color: 'var(--color-card-text)' }}
              >
                Inmates Taught
              </div>
            </div>

            <div
              className="p-5 md:p-6 rounded-lg"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              <div
                className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2"
                style={{ color: 'var(--color-accent-6)' }}
              >
                100+
              </div>
              <div
                className="text-sm md:text-base lg:text-lg"
                style={{ color: 'var(--color-card-text)' }}
              >
                Community Workshops
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
